import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';

// Components
import Modal from '@/views/components/modals/AccessibleModal';
import ScreenerContent from '@/views/containers/search/pages/ScreenerContent';
import ScreenerInstrumentTabs from '@/views/containers/search/partials/ScreenerInstrumentTabs';

// Hooks
import useEnhancedScreener from '@/hooks/useEnhancedScreener';

// Utils
import { ADVANCED_SEARCH_OPTIONS, SCREENER_TAB_MODES } from '@/utils/constants';
import { formatMessage } from '@/utils/i18n';

type Props = {
  className?: string;
  onCancel: () => void;
  show: boolean;
  selectedOption?: ADVANCED_SEARCH_OPTIONS;
  onChangeOption?: (option: ADVANCED_SEARCH_OPTIONS) => void;
};

const ScreenerModal = ({ className, onCancel, selectedOption = ADVANCED_SEARCH_OPTIONS.FUNDS, show, onChangeOption }: Props) => {
  const { user } = useEnhancedScreener();
  const [selectedInstrument, setSelectedInstrument] = useState<ADVANCED_SEARCH_OPTIONS>(selectedOption);

  useEffect(() => {
    if (selectedOption) {
      setSelectedInstrument(selectedOption);
    }
  }, [selectedOption]);

  // Used with mode 'callback' to handle instrument selection
  const handleInstrumentSelect = useCallback(
    (instrument: ADVANCED_SEARCH_OPTIONS) => {
      setSelectedInstrument(instrument);
      onChangeOption?.(instrument);
    },
    [onChangeOption],
  );

  return (
    <Modal show={show} className={classNames('screener-modal', className)} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage('Screener.Title')}</Modal.Title>
        <div className="screener-tabs">
          <ScreenerInstrumentTabs user={user} mode={SCREENER_TAB_MODES.CONTROLLED} selectedId={selectedInstrument} onSelect={handleInstrumentSelect} />
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column">
        <div className="screener" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <ScreenerContent instrumentType={selectedInstrument} insideModal />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ScreenerModal;
